import { BillingPanel } from "./BillingPanel";

export function BillingPage() {
  return (
    <div className="mx-auto max-w-[1500px] pb-8">
      <header className="border-b border-slate-200 pb-6">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-blue-700">
          VIMOS DIGITAL <span className="mx-1 text-slate-300">/</span> OPERACIONES
        </p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">Cobros</h1>
        <p className="mt-2 max-w-2xl text-sm text-slate-500">
          Administra cobros mensuales y anuales, altas y servicios de edición desde un espacio dedicado.
        </p>
      </header>
      <BillingPanel />
    </div>
  );
}
